"use strict";

import { CONSTANTS, getErrorMessage, createResponse } from "../../global/index";
const {
  SET_IDENTITY,
  ERROR_MSG,
  ERROR_STATUS,
} = CONSTANTS;
const ERROR_OBJ = {
  success: false,
  status: ERROR_STATUS,
  code: 500,
  message: ERROR_MSG,
  data: null
};

export default {
  namespaced: true,
  state: {
    identity: null,
  },
  getters: {
    getIdentity(state) {
      return state.identity;
    },
  },
  mutations: {
    [SET_IDENTITY](state, payload) {
      state.identity = payload;
    },
  },
  actions: {
     async setIdentity({ commit }, payload) {
      try {
        commit(SET_IDENTITY, null);
        localStorage.removeItem('identity')

        if(!payload?.Email) return createResponse(false, 'error', 'Sesión no valida', payload)

        const parse =  JSON.stringify(payload)
        localStorage.setItem('identity', parse)
        commit(SET_IDENTITY, payload);
        return payload;
      } catch (error) {
        if(!error?.response?.data?.message) return  ERROR_OBJ;
        return getErrorMessage(error.response.data.message)
      }
    },

    async getIdentity({ commit }) {
      try {
        const identity = localStorage.getItem('identity')
        if(!identity){
          commit(SET_IDENTITY, null);
          return createResponse(false, 'error', 'Sesión no encontrada', payload)
        }

        const parse = JSON.parse(identity)
        if(!parse?.Email){
          localStorage.removeItem('identity')
          commit(SET_IDENTITY, null);
          return createResponse(false, 'error', 'Sesión no valida', parse)
        }
 
        commit(SET_IDENTITY, parse);

        return parse;
      } catch (error) {
        if(!error?.response?.data?.message) return  ERROR_OBJ;
        return getErrorMessage(error.response.data.message)
      }
    },

    logout({ commit }) {
      localStorage.removeItem("identity");
      commit(SET_IDENTITY, null);
    },
  },
};
